// own variables


// Bootstrap, Popper, JQuery
require('./bootstrap');

// Slick
require('slick-carousel');

// AOS
window.AOS = require('aos');

// BaguetteBox
window.baguetteBox = require('baguettebox.js');

require('./navbar');
require('./aos-settings');
require('./baguetteBox-settings');
require('./cf7_subject');
require('./portfolio_service_adaptive_height');
require('./slickSlider');
require('./scroll-animation');
require('./smooth-scrolling');


